import moment from 'moment';

const streaming = {
  dates: {
    test: {
      first: {
        start: moment().set({
          year: 2021, month: 0, date: 28, hours: 16, minutes: 0, seconds: 0
        }),
        end: moment().set({
          year: 2021, month: 0, date: 28, hours: 16, minutes: 30, seconds: 0
        })
      },
      second: {
        start: moment().set({
          year: 2021, month: 0, date: 29, hours: 16, minutes: 0, seconds: 0
        }),
        end: moment().set({
          year: 2021, month: 0, date: 29, hours: 16, minutes: 30, seconds: 0
        })
      },
      third: {
        start: moment().set({
          year: 2021, month: 1, date: 1, hours: 16, minutes: 0, seconds: 0
        }),
        end: moment().set({
          year: 2021, month: 1, date: 1, hours: 16, minutes: 30, seconds: 0
        })
      },
    },
    prod: {
      first: {
        start: moment().set({
          year: 2021, month: 1, date: 4, hours: 21, minutes: 0, seconds: 0
        }),
        end: moment().set({
          year: 2021, month: 1, date: 4, hours: 22, minutes: 45, seconds: 0
        })
      },
      second: {
        start: moment().set({
          year: 2021, month: 1, date: 5, hours: 21, minutes: 0, seconds: 0
        }),
        end: moment().set({
          year: 2021, month: 1, date: 5, hours: 22, minutes: 45, seconds: 0
        })
      },
      third: {
        start: moment().set({
          year: 2021, month: 1, date: 6, hours: 21, minutes: 0, seconds: 0
        }),
        end: moment().set({
          year: 2021, month: 1, date: 6, hours: 22, minutes: 45, seconds: 0
        })
      },
    }
  }
};

export default streaming;
